var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12.6083 0.441895H5.39999C2.79504 0.441895 0.683319 2.55362 0.683319 5.15856V10.8336C0.683319 13.4385 2.79504 15.5502 5.39999 15.5502H12.6083C15.2133 15.5502 17.325 13.4385 17.325 10.8336V5.15856C17.325 2.55362 15.2133 0.441895 12.6083 0.441895Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83332 7.95876C7.02073 7.95876 7.98332 6.99244 7.98332 5.80042C7.98332 4.60841 7.02073 3.64209 5.83332 3.64209C4.64591 3.64209 3.68332 4.60841 3.68332 5.80042C3.68332 6.99244 4.64591 7.95876 5.83332 7.95876Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 12.7337C7.59143 12.7337 9.01666 11.7935 9.01666 10.6337C9.01666 9.47389 7.59143 8.53369 5.83333 8.53369C4.07522 8.53369 2.64999 9.47389 2.64999 10.6337C2.64999 11.7935 4.07522 12.7337 5.83333 12.7337Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4333 10.417H11.5C11.3342 10.417 11.1753 10.3511 11.0581 10.2339C10.9408 10.1167 10.875 9.95775 10.875 9.79199C10.875 9.62623 10.9408 9.46726 11.0581 9.35005C11.1753 9.23284 11.3342 9.16699 11.5 9.16699H14.4083C14.5741 9.16699 14.7331 9.23284 14.8503 9.35005C14.9675 9.46726 15.0333 9.62623 15.0333 9.79199C15.0333 9.95775 14.9675 10.1167 14.8503 10.2339C14.7331 10.3511 14.5741 10.417 14.4083 10.417H14.4333Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 7.2168H10.35C10.1842 7.2168 10.0252 7.15095 9.90803 7.03374C9.79082 6.91653 9.72498 6.75756 9.72498 6.5918C9.72498 6.42604 9.79082 6.26707 9.90803 6.14985C10.0252 6.03264 10.1842 5.9668 10.35 5.9668H14.75C14.9157 5.9668 15.0747 6.03264 15.1919 6.14985C15.3091 6.26707 15.375 6.42604 15.375 6.5918C15.375 6.75756 15.3091 6.91653 15.1919 7.03374C15.0747 7.15095 14.9157 7.2168 14.75 7.2168V7.2168Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.d8e14d043c6b66f674f652458ad357b3.svg";
export { ForwardRef as ReactComponent };